export default __webpack_public_path__ + "static/media/storageUnit1-afterC-768w.21eaff27.png";